import throttle from 'lodash-es/throttle.js';
import getRemBase from 'propel/getRemBase';

const propelInit = function() {
const accordionImageBlocks = document.querySelectorAll(
	'.block-accordion-image'
);

const setAccordionImageTops = () => {
	const remBase = getRemBase();

	const offsets = Array.from(accordionImageBlocks, (block) => {
		const grid = block.querySelector('.block-accordion-image__grid');
		const spacer = block.querySelector('.block-accordion-image__spacer');

		if (!grid || !spacer) {
			return null;
		}

		const gridTop = grid.getBoundingClientRect().top;
		const spacerTop = spacer.getBoundingClientRect().top;

		return { block, imageTop: (spacerTop - gridTop) / remBase };
	});

	offsets.forEach((offset) => {
		if (!offset) {
			return;
		}

		offset.block.style.setProperty('--imageTop', `${offset.imageTop}rem`);
	});
};

const INTERACTION_EVENTS = [
	'scroll',
	'mousemove',
	'touchstart',
	'pointerdown',
	'keydown',
	'focusin',
];

const showAllImages = () => {
	INTERACTION_EVENTS.forEach((event) => {
		document.removeEventListener(event, showAllImages);
	});

	accordionImageBlocks.forEach((block) => {
		block.classList.add('block-accordion-image--images-ready');
	});
};

// Deferred two frames so geometry is read after the browser has painted —
// 'propel-accordion-opened' fires synchronously right after the accordion
// toggles its 'active' class, which would otherwise force this reflow.
const deferSetAccordionImageTops = () => {
	requestAnimationFrame(() => {
		requestAnimationFrame(setAccordionImageTops);
	});
};

if (accordionImageBlocks.length) {
	deferSetAccordionImageTops();

	// Inactive images wait for the first interaction so they don't compete with the initial page load.
	INTERACTION_EVENTS.forEach((event) => {
		document.addEventListener(event, showAllImages, { passive: true });
	});

	window.addEventListener(
		'resize',
		throttle(deferSetAccordionImageTops, 100)
	);

	document.addEventListener(
		'propel-accordion-opened',
		deferSetAccordionImageTops
	);
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['accordion-image'] = window.propel.blocks['accordion-image'] || {};
window.propel.blocks['accordion-image'].script = propelInit;
